import { createLocalAgentBridge, type LocalAgentBridge } from './local-agent-bridge'

let localAgentBridgeSingleton: LocalAgentBridge | null = null

export function getLocalAgentBridge(): LocalAgentBridge {
  if (!localAgentBridgeSingleton) {
    localAgentBridgeSingleton = createLocalAgentBridge()
  }

  return localAgentBridgeSingleton
}
